export const sectionColour = (bgColour: string) => {
  const defaultTheme = {
    backgroundColor: '',
    textColor: '',
    headingColor: '',
    buttonColor: '',
    borderColor: '',
  }
  const greyTheme = {
    backgroundColor: 'bg-light-grey',
    textColor: 'text-main',
    headingColor: 'text-branding-primary',
    buttonColor: 'bg-branding-secondary',
    borderColor: 'border-main',
  }
  const whiteTheme = {
    backgroundColor: 'bg-white',
    textColor: 'text-main',
    headingColor: 'text-branding-primary',
    buttonColor: 'bg-branding-secondary',
    borderColor: 'border-main',
  }
  const brandingTheme = {
    backgroundColor: 'bg-branding-primary',
    textColor: 'text-white',
    headingColor: 'text-white',
    buttonColor: 'bg-white',
    borderColor: 'border-white',
  }

  switch (bgColour) {
    case 'grey':
      return greyTheme
    case 'white':
      return whiteTheme
    case 'branding':
      return brandingTheme
    default:
      return defaultTheme
  }
}
